// IMPORTS
import BooleanTest from '../../js/lib/booleanTest';
import Screen from '../../js/lib/screen';
import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import currentLang from '../../js/lib/currentLang';
import Debounce from '../../js/lib/debounce';

// Browser Detect
// startsWith Polyfill
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		return this.substr(position || 0, searchString.length) === searchString;
	};
}
// Variables
const screen = new Screen();
const isDesktop = 992;
const isMobile = isDesktop - 1;

const navTrigger = document.getElementById('navigationTrigger');

// Url of the Navigation Json
const url = envVar({
	backendPath: '/Navigation/',
	staticPath: 'js/data/navigation.json'
});

// Ajax call, then Vue Function
request().get(url + '?lang=' + currentLang() + '&url=' + window.location).then(function (response) {

	// Set response to Json
	const navigationJson = response;

	// Vue Component
	const navigation = new Vue({
		// Navigation Element ~> this.$el
		el: '#navigation',
		// Define Schema ~> set to null/0

		//this implementation is storing state in DOM data-attributes, not in a state container
		data: {
			primary: '',
			secondary: '',
			tertiary: '',
			selectedPrimaryIndex: -1,
			selectedSecondaryIndex: -1,
			state: {
				primary: 0,
				secondary: 0,
				tertiary: 0
			}
		},
		// When Component is Mounted, run Methods
		mounted: function () {
			const self = this
			self.loadPrimary();
			//self.watchScreenSize()
		},
		watch: {
			secondary: function () {
				const self = this;
				Vue.nextTick(function () {

					var secondaryItems = Array.from(document.getElementsByClassName('secondary__item'));
					secondaryItems.forEach(menuItem => {
						menuItem.addEventListener('keydown', (keyDownEvent) => {
							if (keyDownEvent.key != 'Tab')
								keyDownEvent.preventDefault();

							var currentMenuItem = keyDownEvent.currentTarget;
							var currentItemIndex = secondaryItems.indexOf(currentMenuItem);
							currentMenuItem.tabIndex = -1;
							switch (keyDownEvent.key) {
								case 'Up':
								case 'ArrowUp': {
									self.focusPreviousItem(currentItemIndex, secondaryItems);
									break;
								}
								case 'Down':
								case "ArrowDown": {
									self.focusNextItem(currentItemIndex, secondaryItems);
									break;
								}
								case 'Right':
								case "ArrowRight": {
									var tier3Items = document.getElementsByClassName("tertiary__linkitem");
									tier3Items[0].focus();
									break;
								}
								case 'Left':
								case "ArrowLeft": {
									var primaryItems = Array.from(document.getElementsByClassName("primary__item"));
									var focusableItems = primaryItems.map(function (primaryItem) { return primaryItem.firstElementChild });
									self.focusPreviousItem(self.selectedPrimaryIndex, focusableItems);
									self.reset();
									break;
								}
								case 'Tab': {
									self.handleT2AndT3Tab(keyDownEvent);
									break;
								}
							}

						});
						menuItem.addEventListener('focus', (focusEvent) => {
							self.onSecondaryHoverAndFocus(focusEvent.currentTarget);
						});
						menuItem.addEventListener('mouseover', (focusEvent) => {
							self.onSecondaryHoverAndFocus(focusEvent.currentTarget);
						});
					})
				})
			}
		},
		// Methods
		methods: {
			// Load Primary Menu
			// Only happends when 
			// Component is Mounted
			loadPrimary: function (loc) {
				const self = this;
				self.primary = navigationJson;
			},
			// Load Secondary Menu
			loadSecondary: function (event, index) {
				const self = this;

				if (window.innerWidth <= isMobile && event.target.tagName === 'SPAN') {
					window.location = event.target.dataset.link;
				}
				// See if the Secondary Menu is already open
				else if (!BooleanTest(event.currentTarget.dataset.selected)) {
					// Turn on Screen / Soft Reset
					screen.turnScreenOn();
					//screen.element().style.top = `${self.$el.offsetTop + self.$el.offsetHeight}px`;
					screen.element().style.top = '0px';
					self.setSelectedAttrFalse('.primary__item');
					self.setSelectedAttrFalse('.secondary__item');

					// Place Navigation Interior
					let currentEventTarget = event.currentTarget;

					let leftPlacement = currentEventTarget.offsetLeft;

					let navList = document.getElementById("navList");

					let rightLimit = navList.offsetWidth + navList.offsetLeft;
					let rightPlacement = window.innerWidth - rightLimit;


					let interiorNavigation = self.$el.querySelector('.navigation__interior');
					let interiorNavWidth = interiorNavigation.offsetWidth;

					// first click will result in 0
					if (interiorNavWidth == 0)
						interiorNavWidth = 600;

					if (leftPlacement + interiorNavWidth < rightLimit) {
						interiorNavigation.style.left = `${leftPlacement}px`;
						interiorNavigation.style.right = `inherit`;
						interiorNavigation.style.marginLeft = `0`;

					} else {
						interiorNavigation.style.right = `${rightPlacement}px`;
						interiorNavigation.style.left = 'unset';
					}

					// For Mobile
					self.$el.setAttribute('data-secondary', true);

					// Remove Other Selected Primaries and Set Selected
					self.setSelectedAttrFalse('.primary__item');
					currentEventTarget.setAttribute('data-selected', true);


					//need to extend this for L#
					let titleToShowInBackBtn = self.primary[index].title;
					self.$refs.navigationBack.innerHTML = `<i class="icon ion-chevron-left"></i> ${titleToShowInBackBtn}`;

					self.secondary = self.primary[index].children;
					self.tertiary = '';

					self.loadTertiary('force', 0, index);
				} else {
					self.reset();
				}
			},
			// Load Tertiary
			loadTertiary: function (event, secondIndex, primaryIndex) {
				const self = this;

				if (event === 'force' || (event.type == 'click' && window.innerWidth <= isMobile)) {
					let interiorNavigation = self.$el.querySelector('.navigation__interior');

					// Scroll up to top of tertiary menu on load
					if (interiorNavigation != null && interiorNavigation.scrollTop > 0)
						interiorNavigation.scrollTo(0, 0);

					self.setSelectedAttrFalse('.secondary__item');

					if (event === 'force') {

						Vue.nextTick(function () {
							self.$refs.secondaryItem[secondIndex].setAttribute('data-selected', true);
						});

						// added to show primary title above secondary
						// if (primaryIndex || primaryIndex == 0)
						// 	self.$refs.primaryTitle.innerHTML = `<a href="${self.primary[primaryIndex].href}">${self.primary[primaryIndex].title}</a>`;
					}
					else {
						//not force, click for instance right? 
						//make it explicit

						if (event.target.tagName === 'SPAN') {
							window.location = event.target.dataset.link;
						}

						// the icon is the other click target

						//if it hits no manS land
						else {
							self.$el.setAttribute('data-tertiary', true);

							event.currentTarget.parentElement.setAttribute('data-selected', true);
							event.currentTarget.parentElement.focus();

							//ok this works. Just need to modify the actual back behavior
							self.$refs.navigationBack.innerHTML = `<i class="icon ion-chevron-left"></i> ${self.secondary[secondIndex].title}`;
						}
					}

					self.selectedPrimaryIndex = primaryIndex;
					self.selectedSecondaryIndex = secondIndex;

					if (self.secondary[secondIndex].children.length > 0)
						self.tertiary = self.secondary[secondIndex].children;
					else
						self.tertiary = null;
				}
			},
			// Reset Nav
			// change this to remove the values in the attributes
			// not the attributes themselves.
			// in fact, move attributes to the html if possible
			reset: function () {
				console.log("reset called");
				const self = this;
				screen.turnScreenOff();
				screen.element().style.cssText = '';
				//not removing it here, just changing value
				self.$el.setAttribute('data-open', false);
				self.$el.setAttribute('data-secondary', false);
				self.$el.setAttribute('data-tertiary', false);
				self.setSelectedAttrFalse('.primary__item');
				self.setSelectedAttrFalse('.secondary__item');
				self.selectedPrimaryIndex = -1;
				self.secondary = '';
				self.selectedSecondaryIndex = -1;
				self.tertiary = '';
			},
			// Helpers
			setSelectedAttrFalse: function (selector) {
				const self = this
				let nodeList = self.$el.querySelectorAll(selector)
				for (let i = 0; i < nodeList.length; i++) {
					nodeList[i].setAttribute('data-selected', false);
				}
			},
			onSecondaryHoverAndFocus: function (selectedElement) {
				const self = this
				Vue.nextTick(function () {
					console.log("onSecondaryHoverAndFocus " + self.selectedPrimaryIndex)
					let currentTargetIndex = selectedElement.firstElementChild.dataset.index;
					self.loadTertiary('force', currentTargetIndex, self.selectedPrimaryIndex);
				})
			},
			handleT1KeyDown: function (keyDownEvent) {
				const self = this;
				var primaryMenuItems = document.getElementsByClassName("primary__item");
				var menuItemArray = Array.from(primaryMenuItems);
				var currentMenuItem = keyDownEvent.currentTarget;
				var currentItemIndex = menuItemArray.indexOf(currentMenuItem);
				var currentFocusableLink = currentMenuItem.firstElementChild;
				currentFocusableLink.tabIndex = -1;
				var focusableLinkItems = menuItemArray.map(function (primaryItem) { return primaryItem.firstElementChild });
				switch (keyDownEvent.key) {
					case 'Left':
					case 'ArrowLeft':
						{
							self.focusPreviousItem(currentItemIndex, focusableLinkItems);
							break;
						}
					case 'Right':
					case 'ArrowRight':
						{
							self.focusNextItem(currentItemIndex, focusableLinkItems);
							break;
						}
					case 'Enter':
					case 'Down':
					case 'ArrowDown':
						{
							keyDownEvent.preventDefault();
							if (self.selectedPrimaryIndex == -1)
								self.loadSecondary(keyDownEvent, currentItemIndex);

							Vue.nextTick(function () {
								var secondaryMenuItems = document.getElementsByClassName("secondary__item");
								secondaryMenuItems[0].tabIndex = 0;
								secondaryMenuItems[0].focus();
								currentFocusableLink.tabIndex = 0;
							});
							break;
						}
					case 'Tab':
						{
							// Keep the current item focusable so users can return to the menu bar after moving past it
							currentFocusableLink.tabIndex = 0;
						}
				}
			},
			handleT3KeyDown: function (keyDownEvent) {
				var tertiaryItems = Array.from(document.getElementsByClassName('tertiary__linkitem'));
				const self = this;
				if (keyDownEvent.key != 'Tab' && keyDownEvent.key != 'Enter') {
					keyDownEvent.preventDefault();
				}

				var currentMenuItem = keyDownEvent.currentTarget;
				var currentItemIndex = tertiaryItems.indexOf(currentMenuItem);
				currentMenuItem.tabIndex = -1;

				switch (keyDownEvent.key) {
					case 'Up':
					case 'ArrowUp': {
						self.focusPreviousItem(currentItemIndex, tertiaryItems);
						break;
					}
					case 'Down':
					case "ArrowDown": {
						self.focusNextItem(currentItemIndex, tertiaryItems);
						break;
					}
					case 'Right':
					case "ArrowRight": {
						var primaryItems = Array.from(document.getElementsByClassName("primary__item"));
						var focusableItems = primaryItems.map(function (primaryItem) { return primaryItem.firstElementChild });
						self.focusNextItem(self.selectedPrimaryIndex, focusableItems);
						self.reset();
						break;
					}
					case 'Left':
					case "ArrowLeft": {
						var selectedSecondaryItem = document.getElementsByClassName("secondary__item")[self.selectedSecondaryIndex];
						selectedSecondaryItem.focus();
						break;
					}
					case 'Tab': {
						self.handleT2AndT3Tab(keyDownEvent);
						break;
					}
				}
			},
			handleT2AndT3Tab: function (keyDownEvent) {
				//tab back to T1 item
				const self = this;
				if (keyDownEvent.shiftKey) {
					document.getElementsByClassName("primary__item")[self.selectedPrimaryIndex].focus();
				}
				self.reset();
			},
			focusNextItem: function (currentItemIndex, items) {
				items[currentItemIndex].tabIndex = -1;
				if (currentItemIndex == items.length - 1) {
					var firstItem = items[0];
					firstItem.tabIndex = 0;
					firstItem.focus();
				}
				else {
					var nextItem = items[currentItemIndex + 1];
					nextItem.tabIndex = 0;
					nextItem.focus();
				}
			},
			focusPreviousItem: function (currentItemIndex, items) {
				items[currentItemIndex].tabIndex = -1;
				if (currentItemIndex == 0) {
					var lastItem = items[items.length - 1];
					lastItem.tabIndex = 0;
					lastItem.focus();
				}
				else {
					var previousItem = items[currentItemIndex - 1];
					previousItem.tabIndex = 0;
					previousItem.focus();
				}
			},
			openMobile: function (event) {
				const self = this;

				if (BooleanTest(self.$el.dataset.open)) {
					self.reset();
					self.controlStateOfNavTriggerBtn('close');
					screen.turnScreenOff();
				}
				else {
					self.controlStateOfNavTriggerBtn('open');
					self.$el.setAttribute('data-open', true);
					screen.turnScreenOn();
				}

			},
			getViewportURL: function (url) {
				return 'javascript:void(0)';
			},
			backMobile: function (event) {
				const self = this;

				if (BooleanTest(self.$el.dataset.tertiary)) {
					self.$el.setAttribute('data-tertiary', false);
					self.setSelectedAttrFalse('.secondary__item');

					self.$refs.navigationBack.innerHTML = `<i class="icon ion-chevron-left"></i> ${document.querySelector('.primary__item[data-selected="true"] a').textContent}`;

				}
				else {
					self.$el.setAttribute('data-secondary', false);
					self.setSelectedAttrFalse('.primary__item');
				}
			},
			controlStateOfNavTriggerBtn: function (openOrClose) {
				const self = this;
				if (openOrClose === 'open') {
					navTrigger.setAttribute('data-open', true);
				}
				else if (openOrClose === 'close') {
					navTrigger.setAttribute('data-open', false);
				}
				else {
					return false;
				}
			}
		}
	})

	// Event Listeners
	// Screen

	//but do these touch 
	screen.screenElement.addEventListener('click', () => {
		navigation.reset();
	}, false);

	window.addEventListener('resize', Debounce(() => {
		navigation.reset();
		navigation.controlStateOfNavTriggerBtn('close');
	}, 1000, 'immediate'), false);

	navTrigger.addEventListener('click', (event) => {
		navigation.openMobile(event);
	}, false);
})


// WEBPACK FOOTER //
// ../components/navigation/navigation.js